import { useParams } from 'react-router-dom';
import { Col, Row } from 'antd';

import { Loader } from 'components';

import { useGetRequest, useMemoState } from 'hooks';

import { SnapDisplayComment } from 'codegen';

import { AddComment } from './AddComment';
import { Claim } from './Claim';
import { Comment } from './Comment';

export const Comments = () => {
  const { snapId } = useParams();

  const [allComments, setComments] = useMemoState<SnapDisplayComment[]>();

  const { loading, refresh } = useGetRequest<{ comments: SnapDisplayComment[] }>({
    url: `/snaps/${snapId}/comments`,
    options: {
      refreshDeps: [snapId],
      onSuccess: ({ data: { comments } }) => setComments(comments),
    },
  });

  return (
    <Loader isLoading={loading}>
      <Row>
        <Col xs={20}>
          {allComments?.map((comment) => {
            if (comment.type === SnapDisplayComment.type.CLAIM) {
              return (
                <Claim
                  key={comment.id}
                  comment={comment}
                  refetchComments={refresh}
                />
              );
            }

            return (
              <Comment
                key={comment.id}
                comment={comment}
              />
            );
          })}

          <AddComment setComments={setComments} />
        </Col>
      </Row>
    </Loader>
  );
};
